<template>
  <MountingPortal mountTo="#fifth">
    <div id="fifthslide" class="fifthslide" style="position:relative">
      <!-- <br /> -->
      <div class="imgit hello">
        <img :src="Experience" alt="Animation" />
      </div>
      <div class="imgit hi">
        <img :src="Treat" alt="Animation" />
      </div>
      <div class="imgit hifi">
        <img :src="Treat" alt="Animation" />
      </div>
      <div class="imgit lowfi">
        <img :src="Torch" alt="Animation" />
      </div>

      <div class="headingstyle">Experience</div>
      <div id="span"></div>
      <ul class="timeline">
        <!-- Item 1 -->
        <template v-for="(item, index) in experiences">
          <li :key="index">
            <div :class="index % 2 == 0 ? 'direction-l' : 'direction-r'">
              <div class="flag-wrapper">
                <span class="flag" style="font-family:'Poppins'">{{
                  item.name
                }}</span>
                <span class="time-wrapper"
                  ><span class="time">{{ item.time }}</span></span
                >
              </div>
              <div class="desc">
                {{ item.desc }}
              </div>
            </div>
          </li>
        </template>
      </ul>

      <br />
    </div>
  </MountingPortal>
</template>

<script>
// import Animation from "./images/achievements.gif";
import Treat from "./images/treat.gif";
import Torch from "./images/torch.gif";
import Experience from "./images/experience.gif";
export default {
  data() {
    return {
      //   Animation: Animation,
      Treat: Treat,
      Torch: Torch,
      Experience: Experience,
      experiences: [
        {
          name: "Intern",
          time: "2021 Nov - 2022 Jan",
          desc:
            "Selected for a intern in internshala for LueuerTech and done a website to complete my internship using AOS and Javascript.",
        },
        {
          name: "Lambda core",
          time: "2021 July - present",
          desc:
            "one of the cores of Lambda eka Software Development Club of IITH.",
        },
        {
          name: "Kludge core",
          time: "2021 July - present",
          desc: "one of the cores of Kludge eka Cybersecurity Club of IITH.",
        },
        {
          name: "Elan Coord",
          time: "2021 June - present",
          desc:
            "Part of web team of Elan & Nvision, Cultural fest of IITH and designed three websites mentioned above in projects.",
        },
        {
          name: "Web coord",
          time: "2021 May - present",
          desc:
            "Part of web team of Sunshine, IITH and done new Sunshine website in Gatsby.",
        },
        {
          name: "Media Coord",
          time: "2021 April - present",
          desc:
            "Part of web team of Gymkhana, Student council of IITH and responsible for Gymkhana IITH websites update and ECHO blog.",
        },
        {
          name: "BTECH",
          time: "2020 Nov - present",
          desc:
            "At present studying Bachelor of Technology at IITH in Electrical Engineering.",
        },
        {
          name: "Intermediate",
          time: "2018 - 2020",
          desc:
            "Completed my intermediate i.e  Class - XII at Alphores Junior college  with 98% marks.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.fifthslide {
  margin-left: 22vw;
  width: 78vw;
  /* margin-top: -12px; */
  /* overflow: hidden; */
}
.allow {
  position: absolute;
  bottom: 0;
  left: 10vw;
}
.hello {
  position: absolute;
  top: 10vh;
  right: 0;
}
.hi {
  position: absolute;
  top: 50vh;
  left: 0;
}
.hifi {
  position: absolute;
  top: 90vh;
  right: 0;
}
.lowfi {
  position: absolute;
  bottom: 59vh;
  z-index: 2000;
  left: 0;
}
.imgit img {
  height: 200px;
}
@media screen and (max-width: 500px) {
  .imgit img {
    height: 120px;
  }
}
.fifthslide {
  /* margin: 0; */
  /* padding: 0; */
  /* background: rgb(230, 230, 230);
   */
  /* background: #044094c6; */
  color: rgb(50, 50, 50);
  font-family: "Open Sans", sans-serif;
  font-size: 112.5%;
  /* line-height: 1.6em; */
}

/* ================ The Timeline ================ */

.timeline {
  position: relative;
  width: 660px;
  margin: 0 auto;
  margin-top: 20px;
  padding: 1em 0;
  list-style-type: none;
}

.timeline:before {
  position: absolute;
  left: 50%;
  top: 0;
  content: " ";
  display: block;
  width: 6px;
  height: 100%;
  margin-left: -3px;
  background: rgb(80, 80, 80);
  background: -moz-linear-gradient(
    top,
    rgba(80, 80, 80, 0) 0%,
    rgb(80, 80, 80) 8%,
    rgb(80, 80, 80) 92%,
    rgba(80, 80, 80, 0) 100%
  );
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(30, 87, 153, 1)),
    color-stop(100%, rgba(125, 185, 232, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(80, 80, 80, 0) 0%,
    rgb(80, 80, 80) 8%,
    rgb(80, 80, 80) 92%,
    rgba(80, 80, 80, 0) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(80, 80, 80, 0) 0%,
    rgb(80, 80, 80) 8%,
    rgb(80, 80, 80) 92%,
    rgba(80, 80, 80, 0) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(80, 80, 80, 0) 0%,
    rgb(80, 80, 80) 8%,
    rgb(80, 80, 80) 92%,
    rgba(80, 80, 80, 0) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(80, 80, 80, 0) 0%,
    rgb(80, 80, 80) 8%,
    rgb(80, 80, 80) 92%,
    rgba(80, 80, 80, 0) 100%
  );

  z-index: 5;
}

.timeline li {
  padding: 1em 0;
}

.timeline li:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.direction-l {
  position: relative;
  width: 300px;
  float: left;
  text-align: right;
}

.direction-r {
  position: relative;
  width: 300px;
  float: right;
}

.flag-wrapper {
  position: relative;
  display: inline-block;

  text-align: center;
}

.flag {
  position: relative;
  display: inline;
  background: rgb(248, 248, 248);
  padding: 6px 10px;
  border-radius: 5px;

  font-weight: 600;
  text-align: left;
}

.direction-l .flag {
  -webkit-box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15),
    0 0 1px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.15);
  box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.15);
}

.direction-r .flag {
  -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15),
    0 0 1px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.15);
}

.direction-l .flag:before,
.direction-r .flag:before {
  position: absolute;
  top: 50%;
  right: -40px;
  content: " ";
  display: block;
  width: 12px;
  height: 12px;
  margin-top: -10px;
  background: #fff;
  border-radius: 10px;
  border: 4px solid rgb(255, 80, 80);
  z-index: 10;
}

.direction-r .flag:before {
  left: -40px;
}

.direction-l .flag:after {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  height: 0;
  width: 0;
  margin-top: -8px;
  border: solid transparent;
  border-left-color: rgb(248, 248, 248);
  border-width: 8px;
  pointer-events: none;
}

.direction-r .flag:after {
  content: "";
  position: absolute;
  right: 100%;
  top: 50%;
  height: 0;
  width: 0;
  margin-top: -8px;
  border: solid transparent;
  border-right-color: rgb(248, 248, 248);
  border-width: 8px;
  pointer-events: none;
}

.time-wrapper {
  display: inline;

  line-height: 1em;
  font-size: 0.66666em;
  color: rgb(250, 80, 80);
  vertical-align: middle;
}

.direction-l .time-wrapper {
  float: left;
}

.direction-r .time-wrapper {
  float: right;
}

.time {
  display: inline-block;
  padding: 4px 6px;
  background: rgb(248, 248, 248);
}

.desc {
  margin: 1em 0.75em 0 0;

  font-size: 0.77777em;
  /* font-style: italic; */
  line-height: 1.5em;
}

.direction-r .desc {
  margin: 1em 0 0 0.75em;
}

/* ================ Timeline Media Queries ================ */

@media screen and (max-width: 660px) {
  .timeline {
    width: 100%;
    padding: 4em 0 1em 0;
  }

  .timeline li {
    padding: 2em 0;
  }

  .direction-l,
  .direction-r {
    float: none;
    width: 100%;

    text-align: center;
  }

  .flag-wrapper {
    text-align: center;
  }

  .flag {
    background: rgb(255, 255, 255);
    z-index: 15;
  }

  .direction-l .flag:before,
  .direction-r .flag:before {
    position: absolute;
    top: -30px;
    left: 50%;
    content: " ";
    display: block;
    width: 12px;
    height: 12px;
    margin-left: -9px;
    background: #fff;
    border-radius: 10px;
    border: 4px solid rgb(255, 80, 80);
    z-index: 10;
  }

  .direction-l .flag:after,
  .direction-r .flag:after {
    content: "";
    position: absolute;
    left: 50%;
    top: -8px;
    height: 0;
    width: 0;
    margin-left: -8px;
    border: solid transparent;
    border-bottom-color: rgb(255, 255, 255);
    border-width: 8px;
    pointer-events: none;
  }

  .time-wrapper {
    display: block;
    position: relative;
    margin: 4px 0 0 0;
    z-index: 14;
  }

  .direction-l .time-wrapper {
    float: none;
  }

  .direction-r .time-wrapper {
    float: none;
  }

  .desc {
    position: relative;
    margin: 1em 0 0 0;
    padding: 1em;
    background: rgb(245, 245, 245);
    -webkit-box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);

    z-index: 15;
  }

  .direction-l .desc,
  .direction-r .desc {
    position: relative;
    margin: 1em 1em 0 1em;
    padding: 1em;

    z-index: 15;
  }
}

@media screen and (min-width: 400px ?? max-width: 660px) {
  .direction-l .desc,
  .direction-r .desc {
    margin: 1em 4em 0 4em;
    /* max-width: 200
    px; */
  }
  .desc {
    max-width: 200px;
  }
}
#span {
  width: 6vw;
  padding-bottom: 1vh;
  margin-bottom: 2vh;
  margin: 0 2.2vw;
  border-bottom: 4px solid rgb(47, 65, 223);
}
.headingstyle {
  font-size: 2.8rem;
  margin: 0 2.2vw;
  /* margin-bottom: 20px; */
  font-family: "Zen Antique Soft", serif;
  color: #173b6c;
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .fifthslide {
    margin-left: 0vw;
    width: 100vw;
  }
  #span {
    width: 17vw;
    padding-bottom: 1vh;
    margin-bottom: 2vh;
    border-bottom: 4px solid rgb(47, 65, 223);
  }
}
</style>
